import datePicker from './date-picker.directive.js';

export const candoModule = angular
    .module('channel.directives.cando', [])
    .directive('candoDatePicker', datePicker);
